// extracted by extract-css-chunks-webpack-plugin
module.exports = {"card":"BrandLogoCard-53a01b232186badb","withLink":"BrandLogoCard-c3659828486677c4","isBlock":"BrandLogoCard-d0e02c90bbc595a1","link":"BrandLogoCard-b9449bfdb3fd1661"};